import { adminPriceTableRow } from "./types/index"

export const adminPriceMockData: adminPriceTableRow[] = [
    {
        category: "MATERIALS",
        productName: "ADMIN_PRICE.PRODUCTS.STEEL_SHEET_2MM.name",
        UnitOfMeasure: "SQUARE_METER",
        basePrice: 45.5,
        lastUpdate: "2026-07-01",
    },
    {
        category: "MATERIALS",
        productName: "ADMIN_PRICE.PRODUCTS.ALUMINUM_PROFILE.name",
        UnitOfMeasure: "UNIT",
        basePrice: 12.75,
        lastUpdate: "2026-07-03",
    },
    {
        category: "WORK",
        productName: "ADMIN_PRICE.PRODUCTS.WELDING_WORK.name",
        UnitOfMeasure: "HOUR",
        basePrice: 60,
        lastUpdate: "2026-07-05",
    },
    {
        category: "WORK",
        productName: "ADMIN_PRICE.PRODUCTS.PAINTING_WORK.name",
        UnitOfMeasure: "HOUR",
        basePrice: 40,
        lastUpdate: "2026-07-06",
    },
    {
        category: "GENERAL",
        productName: "ADMIN_PRICE.PRODUCTS.DELIVERY_SURCHARGE.name",
        UnitOfMeasure: "PROPORTION",
        basePrice: 0.15,
        lastUpdate: "2026-07-10",
    },
    {
        category: "GENERAL",
        productName: "ADMIN_PRICE.PRODUCTS.ASSEMBLY_KIT.name",
        UnitOfMeasure: "UNIT",
        basePrice: 89.99,
        lastUpdate: "2026-07-12",
    },
]

